import { Box, Button, Drawer, Divider, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import { Cookies } from "react-cookie";
import { isWeb, goLink } from "assets/js/common";
import { loadLeftAction } from "redux/reducers/left";
import { goAppUrl, exitApp } from "assets/js/apphandle";
import { useHistory } from "react-router-dom";
import {
  loadSidebar,
  loadHideAlert,
  loadLinkAlert,
  loadAlert,
} from "redux/reducers/top";
import jwt_decode from "jwt-decode";
import DrawerStudio from "pages/studio";
import DrawerFresh from "pages/fresh";

export default function Mart(props) {
  const cookies = new Cookies();
  const history = useHistory();
  const dispatch = useDispatch();
  const { linkAlert } = useSelector((state) => state.top);

  const { handleSidebarClose, open, handleAlertClose, goPage, sidebar } = props;

  const { mainSide } = useSelector((state) => state.left);

  const token = cookies.get("X-AUTH-TOKEN");
  const no = cookies.get("no");
  const favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [clublist, setClubList] = useState([]);
  const [fullOpen, setFullOpen] = useState(false);
  const [DrawerOpen, setDrawerOpen] = useState(false);

  const handleFullOpen = () => {
    setFullOpen(true);
  };
  const handleFullClose = () => {
    setFullOpen(false);
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const loadClubList = () => {
    axios
      .get("/api/eh/membership-club/side", {
        params: {
          storeCode: storeCode || "ALL",
        },
      })
      .then((res) => {
        setClubList(res.data.data.membershipClubList);
      });
  };

  const goMRunPage = () => {
    let url = "https://doit5.com/megamart/ZY59/index.html?user_key=" + no;
    if (isWeb) {
      window.open(url, "", "width = 500, height = 800");
    } else {
      goAppUrl(url, 1);
    }
  };

  useEffect(() => {
    loadClubList();
    dispatch(
      loadLeftAction({
        schTp: (favInfo && favInfo.visibleTp) || "1",
      })
    );
  }, []);

  useEffect(() => {
    window.appBackKeyHandle = () => {
      if (open) {
        handleAlertClose();
      } else if (linkAlert) {
        dispatch(loadLinkAlert(""));
      } else if (fullOpen) {
        handleFullClose();
      } else if (DrawerOpen) {
        handleDrawerClose();
      } else if (sidebar) {
        handleSidebarClose();
      } else if (window.location.pathname != "/") {
        history.goBack();
      } else {
        exitApp();
      }
    };
  }, [open, fullOpen, DrawerOpen, sidebar, linkAlert]);

  useEffect(() => {
    window.appBackKeyHandle = () => {
      if (open) {
        handleAlertClose();
      } else if (linkAlert) {
        dispatch(loadLinkAlert(""));
      } else if (fullOpen) {
        handleFullClose();
      } else if (DrawerOpen) {
        handleDrawerClose();
      } else if (sidebar) {
        handleSidebarClose();
      } else if (window.location.pathname != "/") {
        history.goBack();
      } else {
        exitApp();
      }
    };
  });

  return (
    <>
      <Box className="box-type-1 category-box">
        <h4>날마다 쇼핑</h4>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <Link to={"/product-of-week"} onClick={handleSidebarClose}>
              {/* <Link to={"/"} onClick={handleSidebarClose}> */}
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_flyer.svg`}
                />
              </div>
              <span className="nm">전단광고</span>
            </Link>
          </Grid>
          <Grid item xs={3}>
            <Link to={"/event"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_event.svg`}
                />
              </div>
              <span className="nm">이벤트</span>
            </Link>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/coupon");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_coupon.svg`}
                />
              </div>
              <span className="nm">쿠폰</span>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/stamp");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_stamp.svg`}
                />
              </div>
              <span className="nm">스탬프</span>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/shopping-memo");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_shoppingmemo.svg`}
                />
              </div>
              <span className="nm">쇼핑메모</span>
            </Button>
          </Grid>
          {/* <Grid item xs={3}>
            <Link to={"/"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_reservation.svg`}
                />
              </div>
              <span className="nm">사전예약</span>
            </Link>
          </Grid> */}
        </Grid>
      </Box>
      <Divider />

      <Box className="box-type-1 category-box">
        <h4>쌓고</h4>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/my-review");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_myreview.svg`}
                />
              </div>
              <span className="nm">M.리뷰</span>
            </Button>
          </Grid>
          {mainSide && mainSide.atdEvent && (
            <Grid item xs={3}>
              <Button
                onClick={() => {
                  goPage(`/event/${mainSide.atdEvent.seq}`);
                }}
              >
                <div className="img-fixed">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/left_acc.svg`}
                  />
                </div>
                <span className="nm">출석체크</span>
              </Button>
            </Grid>
          )}
          {/* <Grid item xs={3}>
            <Button
              onClick={() => {
                goMRunPage();
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_myrun.svg`}
                />
              </div>
              <span className="nm">M.Run</span>
            </Button>
          </Grid> */}
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/point");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_point.svg`}
                />
              </div>
              <span className="nm">포인트</span>
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Divider />

      <Box className="box-type-1 category-box">
        <h4>즐기고</h4>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                dispatch(
                  loadLinkAlert("https://shoppinglive.naver.com/channels/78178")
                );
                // dispatch(loadAlert(true));
                // goLink("https://shoppinglive.naver.com/channels/78178");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_live.svg`}
                />
              </div>
              <span className="nm">라이브</span>
            </Button>
          </Grid>
          <Grid item xs={3}>
            {/* <Link to={"/studio"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_studiom.svg`}
                />
              </div>
              <span className="nm">스튜디오M</span>
            </Link> */}
            <Button onClick={handleFullOpen}>
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_studiom.svg`}
                />
              </div>
              <span className="nm">스튜디오M</span>
            </Button>
          </Grid>
        </Grid>
      </Box>

      {clublist.length > 0 && (
        <>
          <Divider />
          <Box className="box-type-1 category-box-club">
            <h4>
              <Button
                className="link"
                onClick={() => {
                  goPage("/membership");
                }}
              >
                클럽
              </Button>
            </h4>
            <Grid container spacing={1}>
              {clublist.map((club) => (
                <Grid item xs={3} key={club.cd}>
                  {/* <Button
                    onClick={() => {
                      goPage(`/membership/${club.cd}`);
                    }}
                  >
                    <div>
                      <LazyCDNImage
                        cdnUrl={club.imgUrl}
                        style={{
                          height: "52px",
                          width: "52px",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                    <span className="nm">{club.smplNm}</span>
                  </Button> */}
                  <Link
                    to={`/membership/${club.cd}`}
                    onClick={handleSidebarClose}
                  >
                    <div>
                      <LazyCDNImage
                        cdnUrl={club.imgUrl}
                        style={{
                          height: "52px",
                          width: "52px",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                    <span className="nm">{club.smplNm}</span>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      )}

      <Divider />

      <Box className="box-type-1 category-box">
        <h4>라운지</h4>
        <Grid container spacing={1}>
          <Grid item xs={3} style={{ paddingLeft: 0 }}>
            <Link to={"/recommend-item"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_megatrust.svg`}
                />
              </div>
              <span className="nm">
                {mainSide && mainSide.recommendProductTitle}
              </span>
            </Link>
          </Grid>
          <Grid item xs={3}>
            {/* <Link to={"/recommend-item"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_fresh.svg`}
                />
              </div>
              <span className="nm">신선도원</span>
            </Link> */}
            <Button onClick={handleDrawerOpen}>
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_fresh.svg`}
                />
              </div>
              <span className="nm">신선도원</span>
            </Button>
          </Grid>
        </Grid>
      </Box>

      <DrawerStudio open={fullOpen} handleClose={handleFullClose} />
      <DrawerFresh open={DrawerOpen} handleClose={handleDrawerClose} />
    </>
  );
}
